import { alignCenterCellStyle } from '@common/cellStyles';

import {
  connectionColumnDefinition,
  runStatusColumnDefinition,
  lastRunColumnDefinition,
  plannedRunColumnDefinition,
  totalElapsedTimeColumnDefinition,
  importTrialBalancesColumnDefinition,
  validateTrialBalancesColumnDefinition,
  calculateTaxColumnDefinition,
} from '../columnDefinitions';

export const defaultColumnDefs = {
  suppressSizeToFit: true,
  ...alignCenterCellStyle,
};

export const connectionMonitorPageColumnDefs = [
  connectionColumnDefinition,
  runStatusColumnDefinition,
  lastRunColumnDefinition,
  plannedRunColumnDefinition,
  totalElapsedTimeColumnDefinition,
  importTrialBalancesColumnDefinition,
  validateTrialBalancesColumnDefinition,
  calculateTaxColumnDefinition,
];
